"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _Dialog = _interopRequireDefault(require("../Dialog"));
var _Typography = _interopRequireDefault(require("../Typography"));
var _withTextField = _interopRequireDefault(require("./withTextField"));
var _styles = require("@mui/styles");
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["title", "confirmActionLabel", "cancelActionLabel", "disabledConfirmAction", "onSubmit", "onClose", "onExited", "children", "bodyText", "bodyTextProps", "width", "open"],
  _excluded2 = ["withTextField"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var useStyles = (0, _styles.makeStyles)({
  content: {
    width: function width(_ref) {
      var _width = _ref.width;
      return _width;
    }
  }
});
var ConfirmDialog = function ConfirmDialog(_ref2) {
  var title = _ref2.title,
    confirmActionLabel = _ref2.confirmActionLabel,
    _ref2$cancelActionLab = _ref2.cancelActionLabel,
    cancelActionLabel = _ref2$cancelActionLab === void 0 ? 'Cancel' : _ref2$cancelActionLab,
    _ref2$disabledConfirm = _ref2.disabledConfirmAction,
    disabledConfirmAction = _ref2$disabledConfirm === void 0 ? false : _ref2$disabledConfirm,
    onSubmit = _ref2.onSubmit,
    onClose = _ref2.onClose,
    onExited = _ref2.onExited,
    children = _ref2.children,
    bodyText = _ref2.bodyText,
    _ref2$bodyTextProps = _ref2.bodyTextProps,
    bodyTextProps = _ref2$bodyTextProps === void 0 ? {} : _ref2$bodyTextProps,
    _ref2$width = _ref2.width,
    width = _ref2$width === void 0 ? '600px' : _ref2$width,
    open = _ref2.open,
    props = _objectWithoutProperties(_ref2, _excluded);
  var classes = useStyles({
    width: width
  });
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Dialog["default"], _objectSpread(_objectSpread({
    onClose: onClose,
    disableEscapeKeyDown: true,
    fullScreen: false,
    open: open,
    TransitionProps: {
      onExited: onExited
    }
  }, props), {}, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Dialog["default"].Title, {
      title: title,
      withoutClose: true
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Dialog["default"].Content, {
      className: classes.content,
      children: [bodyText ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Typography["default"], _objectSpread(_objectSpread({}, bodyTextProps), {}, {
        children: bodyText
      })) : null, children ? children : null]
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Dialog["default"].Actions, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Dialog["default"].CloseButton, {
        label: cancelActionLabel
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Dialog["default"].SubmitButton, {
        label: confirmActionLabel,
        disabled: disabledConfirmAction,
        onSubmit: onSubmit
      })]
    })]
  }));
};
var _default = exports["default"] = function _default(_ref3) {
  var withTextFieldProps = _ref3.withTextField,
    props = _objectWithoutProperties(_ref3, _excluded2);
  if (withTextFieldProps) {
    return (0, _withTextField["default"])(ConfirmDialog)(props);
  }
  return ConfirmDialog(props);
};